/** Device-swap quotas reset on this business-calendar boundary everywhere. */
export const DEVICE_SWAP_TIME_ZONE = "America/Winnipeg";
const resetDateFormatter = new Intl.DateTimeFormat("en-CA", {
    day: "numeric",
    month: "long",
    timeZone: DEVICE_SWAP_TIME_ZONE
});
/** "August 1"-style label for the next quota reset, or null when unknown. */
export function deviceSwapResetLabel(nextSwapAvailableAt) {
    if (!nextSwapAvailableAt)
        return null;
    const resetAt = new Date(nextSwapAvailableAt);
    if (Number.isNaN(resetAt.getTime()))
        return null;
    return resetDateFormatter.format(resetAt);
}
export function deviceSwapExhaustedCopy(nextSwapAvailableAt) {
    const resetLabel = deviceSwapResetLabel(nextSwapAvailableAt);
    if (!resetLabel)
        return "0 swaps remaining";
    return `0 swaps remaining · Resets ${resetLabel}`;
}
